import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Button, Col, Row } from 'antd';
import { PreviousCol } from './styles';

interface FooterProps {
	loading: boolean;
	disabled: boolean;
	totalSteps: number;
	currentStep: number;
	onNextClick: () => void;
	onCloseClick: () => void;
	onPreviousClick: () => void;
}

export const Footer: React.FC<FooterProps> = ({
	loading,
	disabled,
	totalSteps,
	currentStep,
	onNextClick,
	onCloseClick,
	onPreviousClick
}) => {
	if (currentStep === totalSteps - 1) {
		return (
			<Col xs={24}>
				<Row justify="center" align="middle" gutter={[0, 8]}>
					<PreviousCol>
						<Button type="default" loading={loading} onClick={onPreviousClick}>
							{I18n.get('Previous')}
						</Button>
					</PreviousCol>
					<Col>
						<Button loading={loading} htmlType="submit" type="primary" onClick={onCloseClick}>
							{I18n.get('Finish')}
						</Button>
					</Col>
				</Row>
			</Col>
		);
	}

	if (currentStep > 0) {
		return (
			<Col xs={24} style={{ display: 'flex', justifyContent: 'center' }}>
				<Row justify="center" align="middle" gutter={[0, 8]}>
					<PreviousCol>
						<Button loading={loading} type="default" onClick={onPreviousClick}>
							{I18n.get('Previous')}
						</Button>
					</PreviousCol>
					<Col>
						<Button
							loading={loading}
							htmlType="submit"
							disabled={disabled}
							type="primary"
							onClick={onNextClick}
						>
							{I18n.get('Next')}
						</Button>
					</Col>
				</Row>
			</Col>
		);
	}

	return (
		<Col xs={24}>
			<Row justify="center">
				<Col>
					<Button
						loading={loading}
						htmlType="submit"
						disabled={disabled}
						type="primary"
						onClick={onNextClick}
					>
						{I18n.get('Next')}
					</Button>
				</Col>
			</Row>
		</Col>
	);
};
